import {
  useOrderReturnRequest,
  useOrderReturnRequests,
  type UseOrderReturnRequestsParams,
} from "@babackapp/private-api-client/client/use-order-return-requests";
import type { ReturnRequest } from "../types";

export function useReturnRequests(params: UseOrderReturnRequestsParams) {
  return useOrderReturnRequests(params);
}

export function useReturnRequest(
  params: UseOrderReturnRequestsParams & { returnRequestId: string },
) {
  return useOrderReturnRequest<ReturnRequest>(params);
}

export type { UseOrderReturnRequestsParams };
